import { isCorporateDemoSession } from "@/constants/corporate-demo";
import { API_URL } from "@/global-state/firebase-settings";

import axios, { AxiosInstance, AxiosRequestConfig } from "axios";

export default class BaseApi {
  accessToken: string | null;
  instagramId: string | null;
  /** 法人 API のスコープ。/api/corporate/organizations/{organizationId}/... に使う */
  organizationId: string | null;

  constructor(accessToken?: string, instagramId?: string, organizationId?: string) {
    if (accessToken) this.accessToken = accessToken;
    if (instagramId) this.instagramId = instagramId;
    if (organizationId) this.organizationId = organizationId;
  }

  /**
   * デモセッション中に実APIへ出ていくのを止めるスタブ
   *
   * デモは Firebase 認証を通らないので Authorization が空のまま。
   * そのままリクエストすると 401 が返り「認証に失敗しました」がそのまま画面に出てしまう。
   * 各フックがサンプルを返すのが正常系だが、ガードの書き漏れが商談中の事故に直結するため、
   * 通信の手前でも止めておく。デモ以外では素通しなので実アカウントの動線には影響しない。
   */
  private get demoStub() {
    return async () => ({ data: null } as any);
  }

  protected get axiosApiConfig() {
    return {
      baseURL: API_URL,
      headers: {
        "Content-Type": "application/json",
        Authorization: this.accessToken ? `Bearer ${this.accessToken}` : "",
      },
      responseType: "json",
    } as AxiosRequestConfig;
  }

  protected get axiosExcelApiConfig() {
    return {
      baseURL: API_URL,
      headers: {
        "Content-Type": "application/json",
        Authorization: this.accessToken ? `Bearer ${this.accessToken}` : "",
      },
      responseType: "blob",
      dataType: "binary",
    } as AxiosRequestConfig;
  }

  protected get get(): AxiosInstance["get"] {
    if (isCorporateDemoSession()) return this.demoStub;
    return axios.create(this.axiosApiConfig).get;
  }

  protected get post(): AxiosInstance["post"] {
    if (isCorporateDemoSession()) return this.demoStub;
    return axios.create(this.axiosApiConfig).post;
  }

  protected get put(): AxiosInstance["put"] {
    if (isCorporateDemoSession()) return this.demoStub;
    return axios.create(this.axiosApiConfig).put;
  }

  protected get patch(): AxiosInstance["patch"] {
    if (isCorporateDemoSession()) return this.demoStub;
    return axios.create(this.axiosApiConfig).patch;
  }

  protected get delete(): AxiosInstance["delete"] {
    if (isCorporateDemoSession()) return this.demoStub;
    return axios.create(this.axiosApiConfig).delete;
  }

  protected get excelGet(): AxiosInstance["get"] {
    if (isCorporateDemoSession()) return this.demoStub;
    return axios.create(this.axiosExcelApiConfig).get;
  }
}
